module.exports = __webpack_public_path__ + "static/media/ic-close.136831e7.svg";